












import {
    defineComponent,
    PropType,
} from '@vue/composition-api';

import SdsPageHeaderBreadcrumbsActionsItem from './SdsPageHeaderBreadcrumbsActionsItem.vue';
import type { PageHeaderActionItem } from './types';

export default defineComponent({
    name: 'SdsPageHeaderBreadcrumbsActions',
    props: {
        items: {
            type: Array as PropType<PageHeaderActionItem[]>,
            required: true,
        },
    },
    components: {
        SdsPageHeaderBreadcrumbsActionsItem,
    },
});
